export default __webpack_public_path__ + "static/media/01.56db3932.png";